import React from 'react';
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  useTheme
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

const SelectQuestion = ({ 
  question, 
  value = '', 
  onChange, 
  interpolateText, 
  answers, 
  error 
}) => {
  const theme = useTheme();

  const handleOptionClick = (optionValue) => {
    onChange(optionValue);
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ mb: 3, fontWeight: 600, whiteSpace: 'pre-line' }}>
        {interpolateText(question.text, answers)}
      </Typography>
      
      <Grid container spacing={2}>
        {question.options?.map((option, index) => {
          const optionValue = typeof option === 'string' ? option : option.value;
          const optionLabel = typeof option === 'string' ? option : option.label;
          const isSelected = value === optionValue;
          
          return (
            <Grid item xs={12} sm={6} md={4} key={optionValue}>
              <Card
                sx={{
                  cursor: 'pointer',
                  transition: 'all 0.2s ease-in-out',
                  border: isSelected 
                    ? `2px solid ${theme.palette.primary.main}` 
                    : '2px solid transparent',
                  bgcolor: isSelected 
                    ? `${theme.palette.primary.main}10` 
                    : 'background.paper',
                  '&:hover': {
                    bgcolor: isSelected 
                      ? `${theme.palette.primary.main}20` 
                      : `${theme.palette.action.hover}`,
                    transform: 'translateY(-2px)',
                    boxShadow: theme.shadows[4]
                  }
                }}
                onClick={() => handleOptionClick(optionValue)}
              >
                <CardContent sx={{ textAlign: 'center', py: 3 }}>
                  {isSelected && (
                    <CheckCircle 
                      sx={{ 
                        color: 'primary.main', 
                        fontSize: 32, 
                        mb: 1 
                      }} 
                    />
                  )}
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      fontWeight: isSelected ? 600 : 500,
                      color: isSelected ? 'primary.main' : 'text.primary'
                    }}
                  >
                    {optionLabel}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
      
      {error && (
        <Typography color="error" variant="body2" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default SelectQuestion;